import SolutionsContainer from "./containers/SolutionsContainer";

export default SolutionsContainer;
